import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { partnerPortalApi, PartnerAccount } from '../../api/partnerPortal';

/**
 * The deliberately minimal landing page for a logged-in Partner
 * account - genuinely no navigation, no module access, nothing to
 * click through to. This is the honest reality of the agreed scope:
 * the login/registration/approval infrastructure is real, but which
 * VConnect data a partner should see is a separate decision for
 * later. This page says so plainly rather than hiding an empty shell
 * behind a broken-looking blank screen.
 */
export function PartnerPortalShellPage() {
  const navigate = useNavigate();
  const [account, setAccount] = useState<PartnerAccount | null>(null);

  useEffect(() => {
    partnerPortalApi.me().then((result) => {
      if (!result.data) { navigate('/login'); return; }
      setAccount(result.data);
    });
  }, [navigate]);

  const handleLogout = async () => {
    await partnerPortalApi.logout();
    navigate('/login');
  };

  if (!account) return <div className="login-page"><p className="muted" style={{ margin: '80px auto', textAlign: 'center' }}>Loading…</p></div>;

  return (
    <div className="login-page">
      <div className="card" style={{ maxWidth: 480, margin: '80px auto', borderTop: '4px solid var(--vri-green)' }}>
        <h1>Welcome, {account.fullName}</h1>
        <p className="muted">{account.organizationName}</p>
        <p style={{ marginTop: '1.5em' }}>
          Your Partner Portal account is active, but access to VConnect data and features has not yet been configured. Please contact your Verdantrise focal point for more information.
        </p>
        <div className="form-actions"><button type="button" onClick={handleLogout}>Log Out</button></div>
      </div>
    </div>
  );
}
